import React from 'react'
import Game from './Game'

export default function Main() {
  return (
    <main className="main">
      <Game />
    </main>
  )
}
